import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  addCreditsToOrganization,
  createOrganization,
  createOrganizationForUser,
  deleteOrganization,
  removeCreditsFromOrganization,
  updateAdminOrganization,
  type CreateOrganizationForUserInput,
} from "./api";
import { invalidateOrganizationQueries } from "./queries";

export function useCreateOrganizationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createOrganization,
    onSuccess: () => invalidateOrganizationQueries(queryClient),
  });
}

type CreateOrganizationForUserMutationOptions = {
  invalidateOrganizationsOnSuccess?: boolean;
};

export function useCreateOrganizationForUserMutation({
  invalidateOrganizationsOnSuccess = true,
}: CreateOrganizationForUserMutationOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateOrganizationForUserInput) =>
      createOrganizationForUser(input),
    onSuccess: invalidateOrganizationsOnSuccess
      ? () => invalidateOrganizationQueries(queryClient)
      : undefined,
  });
}

export function useDeleteOrganizationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteOrganization,
    onSuccess: () => invalidateOrganizationQueries(queryClient),
  });
}

export function useAddOrganizationCreditsMutation() {
  return useMutation({ mutationFn: addCreditsToOrganization });
}

export function useRemoveOrganizationCreditsMutation() {
  return useMutation({ mutationFn: removeCreditsFromOrganization });
}

export function useUpdateAdminOrganizationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAdminOrganization,
    onSuccess: () => invalidateOrganizationQueries(queryClient),
  });
}
